<template>
  <img
    src="https://static.lingvisions.com/public/5d0c4491090942059eedf9ab3f7c6031.svg"
    :class="$style.Container"
  />
</template>

<style lang="less" module>
  .Container {
    width: 42px;
    height: 18px;
    display: block;
    border-top-right-radius: 6px;
  }
</style>
